import { usePdf } from '@anaralabs/lector';
import { ChevronUpIcon, MinusIcon, PlusIcon } from 'lucide-react';
import { useState } from 'react';
import { Button } from '../Button/Button';
import { Icon } from '../ui/Icon';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/Popover';

const ZoomMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const zoom = usePdf((state) => state.zoom);
  const setCustomZoom = usePdf((state) => state.updateZoom);
  const fitToWidth = usePdf((state) => state.zoomFitWidth);

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button size="sm" className="h-7 text-textGray4" variant="ghost">
          {Math.round(zoom * 100)}%
          <ChevronUpIcon size={11} color="#8D8D8D" />
        </Button>
      </PopoverTrigger>

      <PopoverContent align="start" className="w-40">
        <div className="flex flex-row gap-0.5 pb-0.5 mb-0.5 border-b border-border justify-between">
          <div
            className="px-1.5 flex justify-center items-center gap-1 h-7 rounded-md p-1.5 ease-in transition-all duration-150 cursor-pointer text-sm font-medium"
            id="zoomLevelButton"
          >
            <span>{`${Math.round(zoom * 100)}%`}</span>
          </div>
          <div className="flex">
            <Button
              variant="ghost"
              onClick={() => setCustomZoom((zoom) => zoom * 0.9)}
              size="icon"
            >
              <Icon as={MinusIcon} />
            </Button>

            <Button
              variant="ghost"
              onClick={() => setCustomZoom((zoom) => zoom * 1.1)}
              size="icon"
            >
              <Icon as={PlusIcon} />
            </Button>
          </div>
        </div>
        <ul>
          <Button
            variant="ghost"
            className="w-full justify-start"
            size="xs"
            onClick={() => fitToWidth()}
          >
            Page fit
          </Button>

          <Button
            variant="ghost"
            size="xs"
            className="w-full justify-start"
            onClick={() => setCustomZoom(0.5)}
          >
            50%
          </Button>
          <Button
            variant="ghost"
            size="xs"
            className="w-full justify-start"
            onClick={() => setCustomZoom(0.75)}
          >
            75%
          </Button>
          <Button
            variant="ghost"
            size="xs"
            className="w-full justify-start"
            onClick={() => setCustomZoom(1)}
          >
            100%
          </Button>
          <Button
            variant="ghost"
            size="xs"
            className="w-full justify-start"
            onClick={() => setCustomZoom(1.25)}
          >
            125%
          </Button>
          <Button
            variant="ghost"
            size="xs"
            className="w-full justify-start"
            onClick={() => setCustomZoom(1.5)}
          >
            150%
          </Button>
          <Button
            variant="ghost"
            size="xs"
            className="w-full justify-start"
            onClick={() => setCustomZoom(2)}
          >
            200%
          </Button>
          <Button
            variant="ghost"
            size="xs"
            className="w-full justify-start"
            onClick={() => setCustomZoom(3)}
          >
            300%
          </Button>
          <Button
            variant="ghost"
            size="xs"
            className="w-full justify-start"
            onClick={() => setCustomZoom(4)}
          >
            400%
          </Button>
        </ul>
      </PopoverContent>
    </Popover>
  );
};

export default ZoomMenu;
